<div class="w-full h-full">
  <blaze-scroller
    class="h-full"
    #blazeScroller="blazeScroller"
    blazeChatInfiniteScroll
    [viewport]="blazeScroller.getViewport()"
    (scrollTop)="emitLoadMoreMessages(operatorLT)"
    (scrollBottom)="emitLoadMoreMessages(operatorGT)"
  >
    <div
      class="flex flex-col gap-2 absolute min-w-full min-h-full max-w-full"
      [class.center-intro-image]="messagesLength() === 0 && !!introImage"
      [style.padding-top.px]="additionalTopSpacing()"
    >
      @if (introImage) {
        <div class="relative w-full h-full flex items-center justify-center p-[15%]">
          <img class="object-contain object-center" [ngSrc]="introImage" fill priority alt="" />
        </div>
      }
      @for (vm of chatMessagesVm(); track vm.message.id) {
        @if (vm.showNewMessagesSeparatorAtStart) {
          <ng-container *ngTemplateOutlet="newMessageSeparator" />
        }

        <div
          class="relative w-full message-container"
          [style.padding-top.px]="vm.separateFromPrevious ? 8 : 0"
        >
          <ng-container
            *ngTemplateOutlet="
              isEditingEnabled && isTouchMode() && vm.isCurrentUserAuthor
                ? swipeableContainer
                : chatMessage;
              context: { vm: vm }
            "
          />
        </div>

        @if (vm.showNewMessagesSeparatorAtEnd) {
          <ng-container *ngTemplateOutlet="newMessageSeparator" />
        }
      }
      <div #lastMessageReadMarker></div>
    </div>
  </blaze-scroller>
</div>

<ng-template #newMessageSeparator>
  <div data-cy="Conversation:chatMessageSeparator" class="new-message-separator">
    <div class="line"></div>
    <span class="line-text">NEW</span>
  </div>
</ng-template>

<ng-template #messageActions let-message="message">
  <div>
    <button blazeIconButton blazeIconButtonSize="lg" (click)="editMessage(message.id)">
      <mat-icon svgIcon="icon_edit_16" />
    </button>
  </div>
</ng-template>

<ng-template #swipeableContainer let-vm="vm">
  <be-swipeable
    #swipeableElRef
    [enabled]="true"
    [actionsTpl]="messageActions"
    [actionsContext]="{ message: vm.message }"
    (opened)="closeSwipeableElements($event, swipeableElRef)"
  >
    <ng-container *ngTemplateOutlet="chatMessage; context: { vm: vm }" />
  </be-swipeable>
</ng-template>

<ng-template #chatMessage let-vm="vm">
  <be-chat-message
    data-cy="Conversation:chatMessage"
    [class.edit-mode]="vm.editMode"
    [message]="vm.message"
    [showAuthorsImage]="vm.showAuthorsImage"
    [isSentByCurrentUser]="vm.isCurrentUserAuthor"
    [splitLayout]="isSplitLayout()"
    [hasFocus]="vm.isSearchResultSelected"
    [showTimeAgo]="vm.showTimeAgo"
    [time]="vm.time"
    [showSender]="vm.showSender"
    [timeAgo]="vm.timeAgo"
    [modifiedAgo]="vm.modifiedAgo"
    [attr.data-index]="vm.index"
    [colorInfo]="vm.colorInfo"
    [showActionsOnHover]="
      isEditingEnabled && vm.isCurrentUserAuthor && !isTouchMode() && !isViewAsMode()
    "
    [messageEditInProgress]="vm.isMessageEditInProgress"
    [userStatus]="vm.userStatus"
    (editMessage)="editMessage(vm.message.id)"
  />
</ng-template>
